var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { cloneDeep } from "lodash";
import Card from "@irati/ui/src/Layout/Card";
import TenantWalletCreateRefund from "@irati/wallet/apollo/mutation/TenantWalletCreateRefund";
import TenantWalletBalanceQuery from "@irati/wallet/apollo/query/TenantWallet";
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet";
import { FormattedMessage } from "@irati/utils/lang";
import History from "@irati/utils/history";
import tracking from "@irati-tracking/wallet/tenantWallet";
import authentication from "@irati/auth";
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton";
import ErrorText from "@irati/ui/src/ErrorText";
import { formatCurrency } from "@irati/utils/currency/formatCurrency";
import TenantWalletTransferType from "@irati/wallet/enums/TenantWalletTransferType";
import { CreditTransferConfirmationPopup } from "../WalletPopups";
import Amount from "../Amount";
import SelectManager from "./SelectManager";
import Totals from "./Totals";
var DEFAULT_AMOUNT = "10.00";
var TenantWalletRefund = /** @class */ (function (_super) {
    __extends(TenantWalletRefund, _super);
    function TenantWalletRefund() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            amount: DEFAULT_AMOUNT,
            recipients: [],
            showConfirmation: false
        };
        _this.onCompleted = function () {
            tracking.completeTenantWalletTransferCredit();
            _this.setState({ showConfirmation: true });
        };
        _this.addRecipient = function (user) {
            tracking.selectRefundManager();
            var recipients = cloneDeep(_this.state.recipients);
            recipients.push(user);
            _this.setState({ recipients: recipients });
        };
        _this.removeRecipient = function (user) {
            var recipients = cloneDeep(_this.state.recipients).filter(function (u) { return u.uuid !== user.uuid; });
            _this.setState({ recipients: recipients });
        };
        _this.updateAmount = function (amount) {
            tracking.enterRefundValue();
            _this.setState({ amount: amount });
        };
        _this.handleClose = function () {
            History.push({
                pathname: "/wallet/tenant"
            });
        };
        _this.handleRepeatAgain = function () {
            _this.setState({ showConfirmation: false, recipients: [], amount: DEFAULT_AMOUNT });
        };
        _this.returnRewardWalletBalanceVariables = function (user) { return ({
            currency: authentication.defaultUserCurrency(),
            tenantId: authentication.userTenant().uuid,
            userId: user.uuid
        }); };
        _this.handleClick = function (canRefund, mutate) {
            if (canRefund) {
                tracking.clickRefundCTA();
                mutate();
            }
        };
        return _this;
    }
    TenantWalletRefund.prototype.render = function () {
        var _this = this;
        var _a = this.state, amount = _a.amount, recipients = _a.recipients, showConfirmation = _a.showConfirmation;
        var id = this.props.id;
        return (React.createElement(Card, null,
            React.createElement(TenantWalletBalanceQuery, null, function (_a) {
                var data = _a.data;
                var _b = data.tenantWallet, currency = _b.currency, availableBalance = _b.availableBalance;
                var variables = {
                    amount: amount,
                    currency: currency,
                    senderId: recipients[0] ? recipients[0].uuid : null,
                    tenantId: authentication.userTenant().uuid,
                    reason: ""
                };
                var refundAmount = formatCurrency({ currencyCode: currency, isCents: false, value: amount });
                var updatedBalance = {
                    amount: Number(amount) + availableBalance,
                    currency: currency
                };
                return (React.createElement(TenantWalletCreateRefund, { onCompleted: _this.onCompleted, variables: variables }, function (mutate, apolloState) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement(Amount, { amount: amount, id: id, name: "TenantWalletRefundAmount", label: "wallet.tenant.refund.amount.label", updateAmount: _this.updateAmount }),
                        React.createElement(SelectManager, { addRecipient: _this.addRecipient, recipients: recipients, removeRecipient: _this.removeRecipient }),
                        recipients[0] && (React.createElement(RewardWalletBalanceQuery, { useLoader: false, variables: _this.returnRewardWalletBalanceVariables(recipients[0]) }, function (_a) {
                            var rewardWallet = _a.data.rewardWallet, loading = _a.loading;
                            if (loading)
                                return null;
                            var cannotRefund = rewardWallet && rewardWallet.availableBalance < Number(amount);
                            var updatedRewardWalletBalance = {
                                amount: rewardWallet.availableBalance - Number(amount),
                                currency: currency
                            };
                            return (React.createElement(React.Fragment, null,
                                React.createElement(Totals, { amount: Number(amount), currency: currency, recipients: recipients, updatedRewardWalletBalance: updatedRewardWalletBalance, updatedBalance: updatedBalance, wallet: rewardWallet }),
                                cannotRefund && (React.createElement(ErrorText, null,
                                    React.createElement(FormattedMessage, { id: "wallet.tenant.refund.amountError" }))),
                                React.createElement(ValidationButton, { apolloState: apolloState, full: true, large: true, onClick: function () { return _this.handleClick(!cannotRefund, mutate); }, primary: true },
                                    React.createElement(FormattedMessage, { id: "wallet.tenant.refund.button", values: { refundAmount: refundAmount } }))));
                        })),
                        showConfirmation && (React.createElement(CreditTransferConfirmationPopup, { show: showConfirmation, handleClose: _this.handleClose, handleRepeatAgain: _this.handleRepeatAgain, recipients: recipients, transferType: TenantWalletTransferType.REFUND, amount: amount, totalAmount: amount, remainingAmount: updatedBalance.amount, currency: currency }))));
                }));
            })));
    };
    return TenantWalletRefund;
}(PureComponent));
export default TenantWalletRefund;
